module.exports = __webpack_public_path__ + "img/weddings_34_H.07271bea.webp";